import React, { PureComponent } from "react";
import { ResponsiveContainer, RadarChart, Radar, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Tooltip } from "recharts";

const COLORS = ["#C03E5A", "rgba(242, 205, 137, 1)", "#54C06C", "rgba(189, 189, 189, 1)"];

const colorsTwo = [
  "#D57DF5",
  "#7E69D7",
  "#2F80ED",
  "#56CCF2",
  "#52FFD3",
  "#5BCF74",
  "#96E964",
  "#FFCF71",
  "#F97255",
  "#FF84CE"
];

export default class OptimizerRadarChart extends PureComponent {
  render() {
    const { isSmall, data, secondaryColors, unit, onClick } = this.props;

    if (data === undefined) {
      return <div />;
    }

    return (
      <ResponsiveContainer>
        <RadarChart outerRadius={90} width={730} height={250} data={data}>
          <PolarGrid />
          <PolarAngleAxis dataKey="assumption" />
          <PolarRadiusAxis angle={180 / data.length} />
          {data &&
            data[0] &&
            Object.keys(data[0])
              .filter((d) => d !== "assumption")
              .map((d, i) => (
                <Radar
                  key={i}
                  name={d}
                  dataKey={d}
                  stroke={i === 0 ? "#EF7E54" : "#7E69D7"}
                  fill={i === 0 ? "#EF7E54" : "#7E69D7"}
                  fillOpacity={0.0}
                  strokeWidth={3}
                />
              ))}
          <Tooltip />
        </RadarChart>
      </ResponsiveContainer>
    );
  }
}
